<template>
  <div class="view prosecco" data-name="prosecco">
    <ProseccoContent :data="structure" />
    <ProseccoHero :title="title" />
  </div>
</template>

<script>
import ProseccoHero from '@/components/heros/ProseccoHero.vue';
import ProseccoContent from '@/components/contents/ProseccoContent.vue';
import { getComponent } from '../scripts/utils';
import cursor from '@/scripts/cursor';

export default {
  name: 'prosecco',

  components: {
    ProseccoHero,
    ProseccoContent,
  },

  computed: {
    structure() {
      return this.$store.state.bottles[this.$route.params.bottle].structure;
    },

    title() {
      return getComponent(this.structure, 'AppTitle', 'title');
    },
  },

  mounted() {
    this.$nextTick(() => {
      cursor.readd('apollo-prosecco', this.$el);
    });
  },

  beforeDestroy() {
    cursor.remove('apollo-prosecco');
  },
};
</script>
